import { useContext } from "react";
import "./style.scss";
import RegistrationContext from "../../contexts/RegistrationContext";

function Footer() {
  const { screen } = useContext(RegistrationContext);
  const isAdminScreen = typeof screen === "string" && screen.startsWith("admin-");

  const footerClass = isAdminScreen
    ? "bg-slate-950 border-t border-slate-800 mt-auto"
    : "bg-white shadow-inner mt-auto";

  const textClass = isAdminScreen ? "text-slate-400" : "text-gray-500";
  const linkClass = isAdminScreen
    ? "text-blue-400 hover:underline transition-colors"
    : "text-blue-600 hover:underline transition-colors";

  return (
    <footer className={footerClass}>
      <div
        className={`container mx-auto px-4 py-4 text-sm ${textClass} flex flex-wrap justify-center md:justify-between items-center`}
      >
        <div>
          <span>Copyright © IJCAI</span>
          <span className="mx-2">•</span>
          <span>
            Contact us at{" "}
            <a href="mailto:registration@ijcai.org" className={linkClass}>
              registration@ijcai.org
            </a>
          </span>
        </div>
        <div>
          <span>
            IJCAI Privacy Policy (
            <a
              href="https://registration.ijcai.org/IJCAIPrivacyPolicy.pdf"
              target="_blank"
              rel="noreferrer"
              className={linkClass}
            >
              PDF
            </a>
            )
          </span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
